define('formkit/view/form.object/content/base.content.view',['require','underscore','marionette','uikit/uikit','../common/preview.general.view','../common/design.general.view','../rule/rules.composite.view','../../../templates','../common/help.text.view'],function(require) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var UIKit = require('uikit/uikit');
  var PreviewGeneralView = require('../common/preview.general.view');
  var DesignGeneralView = require('../common/design.general.view');
  var RulesCompositeView = require('../rule/rules.composite.view');
  var Templates = require('../../../templates');
  var HelpTextView = require('../common/help.text.view');

  var BaseContentView = UIKit.ItemView.extend({
    className: 'content',

    template: Templates.App['base.content'],

    options: {
      designable: false,
      designing: false,
      divided: false,
      hasAnswer: true,
      readonly: false,
      hasVisibleFailedValidations: false,
      showFailedValidations: false,
      disableLabelAndDescriptionInputFields: false,
    },

    forceUpdate: {
      designable: true,
      divided: true,
      hasAnswer: true,
    },

    ui: {
      answerWrapper: '.answer-wrapper',
    },

    internalViewBindings: {
      previewAnswerView: {
        readonly: 'readonly',
      },
    },

    internalViewOptions: {
      designContainerView: {
        type: UIKit.Container,
      },
      errorMessageView: function() {
        var formObjectState = this.getOption('formObjectState');
        return {
          type: UIKit.Message,
          className: UIKit.Message.prototype.className + ' bottom attached',
          text: 'Error:',
          format: 'error',
          collection: formObjectState ? formObjectState.get('failedVisibleValidationCollection') : null,
          model: formObjectState,
          bindings: {
            visible: 'hasVisibleFailedValidations',
          },
          childBindings: {
            text: 'message',
          },
        };
      },
      designDividerView: function() {
        return {
          type: UIKit.Divider,
          section: true,
          visible: !!this.getOption('designing'),
        };
      },
      designAnswerView: function() {
        return {
          form: this.getOption('form'),
        };
      },
      designGeneralView: function() {
        return {
          type: DesignGeneralView,
          model: this.model,
          form: this.getOption('form'),
          disableLabelAndDescriptionInputFields: this.getOption('disableLabelAndDescriptionInputFields'),
          isTargetable: this.getOption('isTargetable'),
        };
      },
      designTabView: function() {
        return {
          type: UIKit.Tabs,
          visible: !!this.getOption('designing'),
        };
      },
      previewAnswerView: function() {
        return {
          collection: this.getOption('answerValueCollection'),
          form: this.getOption('form'),
          model: this.model,
          designable: this.getOption('designable'),
          readonly: this.getOption('readonly'),
          formObjectState: this.getOption('formObjectState'),
          templateObject: this.model,
        };
      },
      previewGeneralView: function() {
        return {
          type: PreviewGeneralView,
          model: this.model,
        };
      },
      rulesCompositeView: function() {
        return {
          type: RulesCompositeView,
          collection: this.model ? this.model.get('rules') : null,
          form: this.getOption('form'),
        };
      },
      helpTextView: function() {
        return {
          type: HelpTextView,
          model: this.model,
        };
      },
    },

    initialize: function() {
      UIKit.ItemView.prototype.initialize.apply(this, arguments);

      this.formObjectState = this.getOption('formObjectState');
      this.listenTo(this.formObjectState, 'change:hasVisibleFailedValidations', function() {
        this.hasVisibleFailedValidations = this.formObjectState.get('hasVisibleFailedValidations');
      });
      this.hasVisibleFailedValidations = this.formObjectState.get('hasVisibleFailedValidations');
    },

    onChangeDesigning: function() {
      var designing = !!this.getOption('designing');

      this.designTabView.visible = designing;
      this.designDividerView.visible = designing;
    },

    onChangeReadonly: function() {
      var readonly = !!this.getOption('readonly');

      if (this.previewAnswerView) {
        this.previewAnswerView.readonly = readonly;
      }
    },

    onInjectedDesignTabView: function() {
      this.designContainerView = this.buildComponent({ name: 'designContainerView' });
      this.rulesCompositeView = this.buildComponent({ name: 'rulesCompositeView' });
      this.helpTextView = this.buildComponent({ name: 'helpTextView' });

      this.designTabView.add('General', this.designContainerView).add('Display Rules', this.rulesCompositeView);

      var templateObjectType = this.form.getTemplateObjectType(this.model);
      if (templateObjectType && templateObjectType.get('allowsHelpText')) {
        this.designTabView.add('Help Text', this.helpTextView);
      }

      this._setupDesignView();
    },

    _setupDesignView: function() {
      this.designGeneralView = this.buildComponent({ name: 'designGeneralView' });
      this.designAnswerView = this.buildComponent({ name: 'designAnswerView' });

      this.designContainerView.add(this.designGeneralView);

      if (this.designAnswerView) {
        this.designContainerView.add(new UIKit.Divider({ hidden: true })).add(this.designAnswerView);
      }
    },

    updateAttributes: function() {
      this.updateFailedValidationsAttributes();
      this.updateChangedStatusAttributes();
    },

    updateFailedValidationsAttributes: function() {
      var errorClass = 'ui top attached error message';
      var noErrorClass = 'ui basic segment';
      var formObjectState = this.formObjectState;

      if (this.getOption('hasVisibleFailedValidations')) {
        this.ui.answerWrapper
          .removeClass(noErrorClass)
          .addClass(errorClass)
          .css({
            'margin-top': '',
            'margin-bottom': '',
          });
      } else {
        this.ui.answerWrapper
          .removeClass(errorClass)
          .addClass(noErrorClass)
          .css({
            'margin-top': '0',
            'margin-bottom': '0',
          });
      }
    },

    updateChangedStatusAttributes: function() {
      var changedStatusClass = 'ui changed segment';

      if (this.getOption('comparing')) {
        if (this.form.util.isChanged(this.model)) {
          this.ui.answerWrapper
            .addClass(changedStatusClass)
            .removeClass('basic')
            .css({
              'margin-top': '',
              'margin-bottom': '',
              background: '',
            });
        }
      }
    },
  });

  return BaseContentView;
});

